import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import checkedImage from "../../../../../../../../assets/checkedbox.png";
import unCheckedImage from "../../../../../../../../assets/uncheckedBox.png";
import correct from "../../../../../../../../assets/correct.png";
import wrong from "../../../../../../../../assets/wrong.png";
import {
  getWeekAssessment,
  getWeekContentExcludingVideos,
  getWeekPreAssessment,
} from "../../../data/index.js";
import { useQuery, useMutation } from "@tanstack/react-query";
import userService from "../../../../../../../../services/api/user.js";
import adminService from "../../../../../../../../services/api/admin.js";
import { calculateResult } from "../../../utility.js";
import { useSelector } from "react-redux";
import { adminData } from "../../../../../../../../redux/reducers/adminReducer.js";
import Modal from "../../components/Modal.jsx";

function Week3({ enrollmentId, setWeekThreeData }) {
  const { pages } = getWeekContentExcludingVideos(3);
  const activity2 = pages.find((page) => page.id === 4);
  const activity3 = pages.find((page) => page.id === 6);
  const activity4 = pages.find((page) => page.id === 8);
  const activity5 = pages.find((page) => page.id === 10);
  const activity6 = pages.find((page) => page.id === 12);
  const [activityData, setActivityData] = useState([]);
  const [assessmentData, setAssessmentData] = useState([]);
  const [preAssessmentData, setPreAssessmentData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState("");
  const [activityFeedbackId, setActivityFeedbackId] = useState(null);
  const { isAdmin, code } = useSelector(adminData);

  const { questions: assessments } = getWeekAssessment(3);
  const { questions: preAssessments } = getWeekPreAssessment(3);

  // toDo: Fetch User assessment and Activity Data
  const { data, isPending, status, isError } = useQuery({
    queryKey: ["dashboard/tot-feedback-3", enrollmentId, 3],

    queryFn: () =>
      isAdmin
        ? adminService.getUserCourseData(enrollmentId, 3, code)
        : userService.getUserCourseData(enrollmentId, 3),
    enabled: !!enrollmentId,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    keepPreviousData: false,
  });

  useEffect(() => {
    if (!data) return;

    setActivityData(data.activity?.activities);
    setAssessmentData(data.assessment?.assessments);
    setPreAssessmentData(
      data.activity?.activities.find((p) => p.page == 2).answer
    );
    setWeekThreeData(true);

    return () => { };
  }, [data]);

  function getActivityAnswer(activityId) {
    return activityData?.find((activity) => activity.page === activityId)
      ?.answer;
  }

  function getActivityFeedback(activityId, itemId, index) {
    if (!itemId) {
      return activityData?.find((activity) => activity.page === activityId)
        ?.feedback;
    } else {
      const answersList = activityData?.find(
        (activity) => activity.page === activityId
      )?.feedback;
      const answerObject = answersList?.find(
        (activity) => Number(activity.stepId) === Number(itemId)
      )?.value;

      // return answerObject ? answerObject[index] : null;
      return answerObject ? answerObject : null;
    }
  }

  const mutation = useMutation({
    mutationFn: () =>
      adminService.submitAdminFeedback(
        activityData,
        enrollmentId,
        3,
        data?.activity?.user,
        code
      ),
    onSuccess: (data) => {
      setModalData("");
      // Handle success (e.g., show a success message)
    },
    onError: (error) => {
      console.error("Feedback submission error:", error);
      setModalData("");
      // Handle error (e.g., show an error message)
    },
  });

  const handleModalOpen = () => {
    setShowModal(true);
  };

  const handleModalClose = () => {
    setActivityFeedbackId(null);
    setShowModal(false);
  };

  const submitFeedback = (value) => {
    if (!activityFeedbackId?.itemId) {
      const answerData = activityData.find(
        (item) => item.page === activityFeedbackId.activityId
      );
      answerData.feedback = value;
      handleModalClose();
      mutation.mutate();
    } else {
      const answerData = activityData?.find(
        (item) => item.page === activityFeedbackId.activityId
      );

      if (!answerData.feedback) {
        answerData.feedback = [];
      }

      const existingFeedbackIndex = answerData.feedback.findIndex(
        (item) => item.stepId === activityFeedbackId.itemId
      );

      if (existingFeedbackIndex >= 0) {
        answerData.feedback[existingFeedbackIndex].value = value;
      } else {
        answerData.feedback.push({
          stepId: activityFeedbackId.itemId,
          value: value,
        });
      }

      handleModalClose();
      setModalData("");
      mutation.mutate();
    }
  };

  function getOptionDetails(option) {
    const options = [
      {
        id: "A",
        text: "Active Listening",
      },
      {
        id: "B",
        text: "Encouragement & Praise",
      },
      {
        id: "C",
        text: "Fairness & Consistency",
      },
      {
        id: "D",
        text: "Emotional Support",
      },
      {
        id: "E",
        text: "Showing Interest in Students' Lives",
      },
    ];

    return options.find((item) => item.id === option) || null;
  }

  if (isPending) {
    return <div>Loading...</div>;
  }

  if (data?.status === "failed" || isError) {
    return <div>{data?.message || "Internal server error!"}</div>;
  }

  const score =
    calculateResult(assessments, assessmentData, assessments?.length) || 0;

  const renderActivity3 = (question, answer, feedback, activityId, index) => {
    return (
      <div key={index}>
        <div className="d-flex gap-3 align-items-center">
          <h2 className="text-blue fs-md-1 text-nowrap">
            Questions {index + 1}:
          </h2>
          <p className="text-blue fs-md-4 mb-0">{question.title}</p>
        </div>

        <div>
          <span className="bg-green rounded-3 text-white px-1 px-md-3 py-1">
            Within your control:
          </span>
        </div>

        <div className="d-flex gap-3 align-items-center">
          <h2 className="text-gray fs-md-1 mb-0">Answer:</h2>
          <p className="fs-md-5 flex-grow-1 mb-0">{answer?.[0]}</p>
          {isAdmin && !feedback && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId, itemId: index + 1 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
        </div>

        <div>
          <span className="bg-orange rounded-3 text-muted px-1 px-md-3 py-1">
            Outside your control:
          </span>
        </div>

        <div className="d-flex gap-3 align-items-center">
          <h2 className="text-gray fs-md-1 mb-0">Answer:</h2>
          <p className="fs-md-5 flex-grow-1 mb-0">{answer?.[1]}</p>
        </div>

        {feedback && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start mb-0">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-1 p-md-2 rounded mb-0">
              {feedback}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(feedback);
                  setActivityFeedbackId({ activityId, itemId: index + 1 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {/* PreAssesment 1 */}
      <p className="bg-blue py-1 px-1 py-md-3 px-md-2 text-white d-inline-block rounded-5 fs-md-4">
        Pre-Assessment
      </p>
      <hr />
      {preAssessments.map(({ id, question, options, correctOption }, i) => {
        // todo:  fetch preassesment data from backend and switch
        const selectedAnswer = Array.isArray(preAssessmentData)
          ? preAssessmentData.find((answer) => answer.id === id)?.value
          : undefined;
        return (
          <>
            <div className="d-flex gap-3" key={i}>
              <p
                className="text-blue fs-md-1 text-nowrap week-2-question-text fw-bold"
                style={{ fontSize: 1 + "em" }}
              >
                Questions {i + 1}:
              </p>
              <p
                className="text-blue fs-md-4 week-2-question-text"
                style={{ fontSize: 1 + "em" }}
              >
                {question}
              </p>
            </div>
            {options.map((option, index) => {
              const optionKey = Object.keys(option)[0];
              const optionText = option[optionKey];
              const isCorrectOption = correctOption === optionText;
              const isAnswer = selectedAnswer === optionText;
              // console.log(assessmentData,"AssessmentData")

              return (
                <div
                  key={index}
                  className="d-flex gap-md-2 p-0 p-md-1 mb-3 justify-content-between"
                >
                  <div className="d-flex gap-md-2 p-1">
                    <img
                      src={isAnswer ? checkedImage : unCheckedImage}
                      alt={`Option ${optionKey}`}
                      style={{ width: 20, height: 20 }}
                    />
                    <div
                      className="week-2-question-text text-gray"
                      style={{ fontSize: 1 + "em" }}
                    >{`${optionText}. ${option.text}`}</div>
                  </div>
                  {isCorrectOption ? (
                    <p className="d-flex gap-1">
                      {" "}
                      <img
                        src={correct}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />{" "}
                      Correct
                    </p>
                  ) : (
                    <p className="d-flex gap-1">
                      {" "}
                      <img
                        src={wrong}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />
                      Wrong
                    </p>
                  )}
                </div>
              );
            })}
          </>
        );
      })}
      <hr />
      {/* Activity 1 */}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 1
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Question 1:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity2.steps[0].questions[0].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const answers = getActivityAnswer(activity2.id);
            if (!Array.isArray(answers) || !answers[0] || !answers[0].value)
              return "";
            return answers[0].value;
          })()}
        </p>

        {isAdmin &&
          !getActivityFeedback(activity2.id, 1) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity2.id, itemId: 1 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity2.id, 1) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity2.id, 1)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity2.id, 1));
                  setActivityFeedbackId({ activityId: activity2.id, itemId: 1 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Question 2:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity2.steps[0].questions[0].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const answers = getActivityAnswer(activity2.id);
            if (!Array.isArray(answers) || !answers[1] || !answers[1].value)
              return "";
            return answers[1].value;
          })()}
        </p>

        {isAdmin &&
          !getActivityFeedback(activity2.id, 2) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity2.id, itemId: 2 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity2.id, 2) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity2.id, 2)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity2.id, 2));
                  setActivityFeedbackId({ activityId: activity2.id, itemId: 2 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />

      {/* Activity 2  */}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 2
      </p>
      <p
        className="text-gray fs-md-4 week-2-question-text"
        accordion
        style={{ fontSize: 1 + "em" }}
      >
        {activity3.steps[0].instructions.map((text) => (
          <>
            <span className="text-gray">{text}</span>
            <br />
          </>
        ))}
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 1:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity3.steps[1].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        {(() => {
          const answers = getActivityAnswer(activity3.id);
          if (!Array.isArray(answers))
            return <p className="text-gray">Loading...</p>;

          const step = answers.find(
            (a) => a.stepId === activity3.steps[1].stepId
          );
          if (!step || !step.value)
            return <p className="text-gray">Loading...</p>;

          const details = getOptionDetails(step.value);
          if (!details) return <p className="text-gray">Loading...</p>;

          return (
            <>
              <p className="text-gray">
                {details.id}. {details.text}
              </p>
            </>
          );
        })()}
        {isAdmin &&
          !getActivityFeedback(activity3.id, 2) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity3.id, itemId: 2 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity3.id, 2) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity3.id, 2)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity3.id, 2));
                  setActivityFeedbackId({ activityId: activity3.id, itemId: 2 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 2:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity3.steps[2].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        {(() => {
          const answers = getActivityAnswer(activity3.id);
          if (!Array.isArray(answers))
            return <p className="text-gray">Loading...</p>;

          const step = answers.find(
            (a) => a.stepId === activity3.steps[2].stepId
          );
          if (!step || !step.value)
            return <p className="text-gray">Loading...</p>;

          const details = getOptionDetails(step.value);
          if (!details) return <p className="text-gray">Loading...</p>;

          return (
            <>
              <p className="text-gray">
                {details.id}. {details.text}
              </p>
            </>
          );
        })()}
        {isAdmin &&
          !getActivityFeedback(activity3.id, 3) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity3.id, itemId: 3 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity3.id, 3) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity3.id, 3)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity3.id, 3));
                  setActivityFeedbackId({ activityId: activity3.id, itemId: 3 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 3:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity3.steps[3].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        {(() => {
          const answers = getActivityAnswer(activity3.id);
          if (!Array.isArray(answers))
            return <p className="text-gray">Loading...</p>;

          const step = answers.find(
            (a) => a.stepId === activity3.steps[3].stepId
          );
          if (!step || !step.value)
            return <p className="text-gray">Loading...</p>;

          const details = getOptionDetails(step.value);
          if (!details) return <p className="text-gray">Loading...</p>;

          return (
            <>
              <p className="text-gray">
                {details.id}. {details.text}
              </p>
            </>
          );
        })()}
        {isAdmin &&
          !getActivityFeedback(activity3.id, 4) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity3.id, itemId: 4 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity3.id, 4) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity3.id, 4)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity3.id, 4));
                  setActivityFeedbackId({ activityId: activity3.id, itemId: 4 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 4:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity3.steps[4].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        {(() => {
          const answers = getActivityAnswer(activity3.id);
          if (!Array.isArray(answers))
            return <p className="text-gray">Loading...</p>;

          const step = answers.find(
            (a) => a.stepId === activity3.steps[4].stepId
          );
          if (!step || !step.value)
            return <p className="text-gray">Loading...</p>;

          const details = getOptionDetails(step.value);
          if (!details) return <p className="text-gray">Loading...</p>;

          return (
            <>
              <p className="text-gray">
                {details.id}. {details.text}
              </p>
            </>
          );
        })()}
        {isAdmin &&
          !getActivityFeedback(activity3.id, 5) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity3.id, itemId: 5 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity3.id, 5) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity3.id, 5)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity3.id, 5));
                  setActivityFeedbackId({ activityId: activity3.id, itemId: 5 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 5:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity3.steps[5].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        {(() => {
          const answers = getActivityAnswer(activity3.id);
          if (!Array.isArray(answers))
            return <p className="text-gray">Loading...</p>;

          const step = answers.find(
            (a) => a.stepId === activity3.steps[5].stepId
          );
          if (!step || !step.value)
            return <p className="text-gray">Loading...</p>;

          const details = getOptionDetails(step.value);
          if (!details) return <p className="text-gray">Loading...</p>;

          return (
            <>
              <p className="text-gray">
                {details.id}. {details.text}
              </p>
            </>
          );
        })()}
        {isAdmin &&
          !getActivityFeedback(activity3.id, 6) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity3.id, itemId: 6 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity3.id, 6) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity3.id, 6)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity3.id, 6));
                  setActivityFeedbackId({ activityId: activity3.id, itemId: 6 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />

      {/* Activity 3 */}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 3
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Question 1:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity4.steps[0].questions[0].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const answers = getActivityAnswer(activity4.id);
            if (!Array.isArray(answers) || !answers[0] || !answers[0].value)
              return "";
            return answers[0].value;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity4.id, 1) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity4.id, itemId: 1 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity4.id, 1) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity4.id, 1)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity4.id, 1));
                  setActivityFeedbackId({ activityId: activity4.id, itemId: 1 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Question 2:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity4.steps[0].questions[0].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const answers = getActivityAnswer(activity4.id);
            if (!Array.isArray(answers) || !answers[1] || !answers[1].value)
              return "";
            return answers[1].value;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity4.id, 2) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity4.id, itemId: 2 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity4.id, 2) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity4.id, 2)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity4.id, 2));
                  setActivityFeedbackId({ activityId: activity4.id, itemId: 2 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />

      {/* Activity 4*/}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 4
      </p>
      <p
        className="text-gray fs-md-4 week-2-question-text"
        accordion
        style={{ fontSize: 1 + "em" }}
      >
        {activity5.steps[0].instructions.map((text) => (
          <>
            <span className="text-gray">{text}</span>
            <br />
          </>
        ))}
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Example:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity5.steps[1].questions[0].question}
        </p>
      </div>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-white bg-orange rounded-3 px-4 fs-md-1 text-gray week-2-question-text mb-3"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Strength
        </p>
        <p className="fs-md-5 flex-grow-1 text-gray">Perseverance</p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-white bg-green rounded-3 px-4 fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Praise
        </p>
        <p className="fs-md-5 flex-grow-1 text-gray">
          I really admire the persistence you’ve shown in tackling this task.
          Your effort is inspiring, and it’s paying off
        </p>
      </div>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 1:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity5.steps[2].questions[0].question}
        </p>
      </div>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-white bg-orange rounded-3 px-4 fs-md-1 text-gray week-2-question-text mb-3"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Strength
        </p>
        <p className="fs-md-5 flex-grow-1 text-gray">
          {(() => {
            const answers = getActivityAnswer(activity5.id);
            if (!Array.isArray(answers) || !answers[0] || !answers[0].strength)
              return "";
            return answers[0].strength;
          })()}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-white bg-green rounded-3 px-4 fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Praise
        </p>
        <p className="fs-md-5 flex-grow-1 text-gray">
          {(() => {
            const answers = getActivityAnswer(activity5.id);
            if (
              !Array.isArray(answers) ||
              !answers[0] ||
              !answers[0].praiseExample
            )
              return "";
            return answers[0].praiseExample;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity5.id, 3) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity5.id, itemId: 3 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity5.id, 3) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity5.id, 3)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity5.id, 3));
                  setActivityFeedbackId({ activityId: activity5.id, itemId: 3 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 2:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity5.steps[3].questions[0].question}
        </p>
      </div>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-white bg-orange rounded-3 px-4 fs-md-1 text-gray week-2-question-text mb-3"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Strength
        </p>
        <p className="fs-md-5 flex-grow-1 text-gray">
          {(() => {
            const answers = getActivityAnswer(activity5.id);
            if (!Array.isArray(answers) || !answers[1] || !answers[1].strength)
              return "";
            return answers[1].strength;
          })()}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-white bg-green rounded-3 px-4 fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Praise
        </p>
        <p className="fs-md-5 flex-grow-1 text-gray">
          {(() => {
            const answers = getActivityAnswer(activity5.id);
            if (
              !Array.isArray(answers) ||
              !answers[1] ||
              !answers[1].praiseExample
            )
              return "";
            return answers[1].praiseExample;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity5.id, 4) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity5.id, itemId: 4 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity5.id, 4) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity5.id, 4)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity5.id, 4));
                  setActivityFeedbackId({ activityId: activity5.id, itemId: 4 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      {/* Activity 5*/}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 5
      </p>
      <p
        className="text-gray fs-md-4 week-2-question-text"
        accordion
        style={{ fontSize: 1 + "em" }}
      >
        {activity6.steps[0].instructions.map((text) => (
          <>
            <span className="text-gray">{text}</span>
            <br />
          </>
        ))}
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 1:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity6.steps[1].questions[0].question}
        </p>
      </div>
      <hr />
      <p
        className="text-gray fs-md-4 week-2-question-text"
        accordion
        style={{ fontSize: 1 + "em" }}
      >
        {activity6.steps[2].questions[0].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1 text-gray">
          {(() => {
            const answers = getActivityAnswer(activity6.id);
            if (!Array.isArray(answers) || !answers[0] || !answers[0].reflect)
              return "";
            return answers[0].reflect;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity6.id, 1) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity6.id, itemId: 1 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity6.id, 1) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity6.id, 1)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity6.id, 1));
                  setActivityFeedbackId({ activityId: activity6.id, itemId: 1 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-gray fs-md-4 week-2-question-text"
        accordion
        style={{ fontSize: 1 + "em" }}
      >
        {activity6.steps[2].questions[1].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1 text-gray">
          {(() => {
            const answers = getActivityAnswer(activity6.id);
            if (!Array.isArray(answers) || !answers[0] || !answers[0].explain)
              return "";
            return answers[0].explain;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity6.id, 2) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity6.id, itemId: 2 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity6.id, 2) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity6.id, 2)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity6.id, 2));
                  setActivityFeedbackId({ activityId: activity6.id, itemId: 2 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-gray fs-md-4 week-2-question-text"
        accordion
        style={{ fontSize: 1 + "em" }}
      >
        {activity6.steps[2].questions[2].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1 text-gray">
          {(() => {
            const answers = getActivityAnswer(activity6.id);
            if (
              !Array.isArray(answers) ||
              !answers[0] ||
              !answers[0].suggestion
            )
              return "";
            return answers[0].suggestion;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity6.id, 3) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity6.id, itemId: 3 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity6.id, 3) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity6.id, 3)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity6.id, 3));
                  setActivityFeedbackId({ activityId: activity6.id, itemId: 3 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 2:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity6.steps[3].questions[0].question}
        </p>
      </div>
      <hr />
      <p
        className="text-gray fs-md-4 week-2-question-text"
        accordion
        style={{ fontSize: 1 + "em" }}
      >
        {activity6.steps[2].questions[0].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1 text-gray">
          {(() => {
            const answers = getActivityAnswer(activity6.id);
            if (!Array.isArray(answers) || !answers[1] || !answers[1].reflect)
              return "";
            return answers[1].reflect;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity6.id, 4) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity6.id, itemId: 4 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity6.id, 4) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity6.id, 4)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity6.id, 4));
                  setActivityFeedbackId({ activityId: activity6.id, itemId: 4 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-gray fs-md-4 week-2-question-text"
        accordion
        style={{ fontSize: 1 + "em" }}
      >
        {activity6.steps[2].questions[1].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1 text-gray">
          {(() => {
            const answers = getActivityAnswer(activity6.id);
            if (!Array.isArray(answers) || !answers[1] || !answers[1].explain)
              return "";
            return answers[1].explain;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity6.id, 5) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity6.id, itemId: 5 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity6.id, 5) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity6.id, 5)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity6.id, 5));
                  setActivityFeedbackId({ activityId: activity6.id, itemId: 5 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-gray fs-md-4 week-2-question-text"
        accordion
        style={{ fontSize: 1 + "em" }}
      >
        {activity6.steps[2].questions[2].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1 text-gray">
          {(() => {
            const answers = getActivityAnswer(activity6.id);
            if (
              !Array.isArray(answers) ||
              !answers[1] ||
              !answers[1].suggestion
            )
              return "";
            return answers[1].suggestion;
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity6.id, 6) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity6.id, itemId: 6 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity6.id, 6) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity6.id, 6)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity6.id, 6));
                  setActivityFeedbackId({ activityId: activity6.id, itemId: 6 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />

      {/* Assesment 1 */}
      <p className="bg-blue py-1 px-1 py-md-3 px-md-2 text-white d-inline-block rounded-5 fs-md-4">
        Post-Assessment
      </p>
      <hr />
      {assessments.map(({ id, question, options, correctOption }, i) => {
        const selectedAnswer = assessmentData?.find(
          (answer) => answer.id === id
        )?.value;
        return (
          <>
            <div className="d-flex gap-3" key={i}>
              <p
                className="text-blue fs-md-1 text-nowrap week-2-question-text fw-bold"
                style={{ fontSize: 1 + "em" }}
              >
                Questions {i + 1}:
              </p>
              <p
                className="text-blue fs-md-4 week-2-question-text"
                style={{ fontSize: 1 + "em" }}
              >
                {question}
              </p>
            </div>
            {options.map((option, index) => {
              const optionKey = Object.keys(option)[0];
              const optionText = option[optionKey];
              const isCorrectOption = correctOption === optionText;
              const isAnswer = selectedAnswer === optionText;
              // console.log(assessmentData,"AssessmentData")

              return (
                <div
                  key={index}
                  className="d-flex gap-md-2 p-0 p-md-1 mb-3 justify-content-between"
                >
                  <div className="d-flex gap-md-2 p-1">
                    <img
                      src={isAnswer ? checkedImage : unCheckedImage}
                      alt={`Option ${optionKey}`}
                      style={{ width: 20, height: 20 }}
                    />
                    <div
                      className="week-2-question-text text-gray"
                      style={{ fontSize: 1 + "em" }}
                    >{`${optionText}. ${option.text}`}</div>
                  </div>
                  {isCorrectOption ? (
                    <p className="d-flex gap-1">
                      {" "}
                      <img
                        src={correct}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />{" "}
                      Correct
                    </p>
                  ) : (
                    <p className="d-flex gap-1">
                      {" "}
                      <img
                        src={wrong}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />
                      Wrong
                    </p>
                  )}
                </div>
              );
            })}
          </>
        );
      })}
      <hr />
      {/* Weekly Report */}
      <div className="bg-button p-3 p-md-5 rounded-4">
        <h2 className="text-white fs-md-1">Weekly Report</h2>
        <div className="d-flex flex-column flex-md-row gap-4">
          <h2 className="text-gray fs-md-1 ratio-1x1 bg-aqua rounded-4 p-3 p-md-5 d-flex justify-content-center border border-6 border-blue">
            {score}%
          </h2>
          <p className="text-white">
            {score < 40
              ? "You’ve taken an important first step in exploring Social and Emotional Learning and Positive Psychology. You’ve started to understand the value of emotional awareness, relationship skills, and teacher wellbeing. However, it seems you may still be building a full grasp of how SEL connects to classroom practice. Revisit the lessons and take time to reflect on how self-awareness and self-management can shape your approach to teaching. Don’t hesitate to ask questions or discuss ideas with your peers; collaboration is one of the best ways to deepen understanding. Every teacher starts somewhere, and your willingness to learn is already a sign of growth"
              : score < 60
                ? "Good effort! You’re beginning to grasp key SEL and Positive Psychology principles such as self-awareness, empathy, and the importance of wellbeing in the classroom. You have a fair understanding of how emotional intelligence supports both teachers and students, but there’s room to strengthen your practical application. Try focusing on mindfulness and emotional regulation strategies in your daily teaching routine. Reflect after each class, ‘How did your emotional state affect your students' responses?’ The more intentional you are, the more confident and balanced you’ll become in integrating SEL principles effectively."
                : score < 80
                  ? "Well done! You’ve shown a strong understanding of SEL and Positive Psychology concepts and are starting to connect them meaningfully to your classroom practice. You recognize how empathy, relationship-building, and emotional regulation influence learning outcomes. To keep improving, aim to apply SEL more consistently, model calm responses to challenges, and build structured moments for reflection or gratitude in your lessons. You’re well on your way to creating a classroom culture rooted in care, connection, and emotional growth."
                  : score < 95
                    ? "Excellent work! You’ve demonstrated a clear understanding of SEL and Positive Psychology competencies and how its principles can transform both teaching and learning. You’ve likely developed effective strategies for fostering empathy, self-regulation, and resilience in your students, and you understand the importance of teacher wellbeing in sustaining those practices. Keep refining your skills by mentoring peers or sharing SEL practices in team meetings. Continue to model emotional intelligence in every interaction, and you will build the kind of classroom where students feel safe, motivated, and valued."
                    : score <= 100
                      ? "Outstanding achievement! You’ve shown exceptional mastery of Social and Emotional Learning. You not only understand the theory but also demonstrate how to live it out in your teaching, balancing self-awareness, empathy, and resilience with skill. Your approach likely fosters deep trust, engagement, and growth in your students. Continue to inspire others by leading discussions on SEL implementation and supporting colleagues who are just beginning their journey. Your dedication to nurturing emotional wellbeing in education sets a powerful example. Keep shining, the ripple effect of your work will last far beyond the classroom."
                      : ""}
          </p>
        </div>
        <Modal
          isOpen={showModal}
          closeModal={handleModalClose}
          data={modalData}
          handleSubmit={submitFeedback}
        />
      </div>
    </>
  );
}

export default Week3;
